import { render, staticRenderFns } from "./Drugbook.vue?vue&type=template&id=05aef1dc&"
import script from "./Drugbook.vue?vue&type=script&lang=js&"
export * from "./Drugbook.vue?vue&type=script&lang=js&"
import style0 from "./Drugbook.vue?vue&type=style&index=0&id=05aef1dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports